<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="mb-3">
            <router-link to="/panel_aliados" class="btn btn-orange rounded-pill">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>
            <div class="float-end">
              <router-link v-bind:to="'/aliado/info_secundaria/' + id_aliado" class="text-muted">
                Información secundaria <i class="bx bx-chevron-right"></i>
              </router-link>
            </div>
            <br />
          </div>
          <div class="mt-2 mb-3">
            <h3 class="text-orange fw-bold">{{ aliado.nombre_aliado }}</h3>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="text-orange fw-bold">Información básica</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12 form-group">
                  <label>Ciudad <small>(ciudad de ubicación Aliado)</small></label>
                  <v-select v-model="aliado.sucursal" label="sucursal" :options="sucursales" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    "></v-select>
                  <div class="text-end">
                    <a v-on:click="load_nueva_ciudad = true" href="javascript:void(0)">Crear nueva</a>
                  </div>
                </div>
                <div v-if="load_nueva_ciudad" class="col-lg-12 form-group">
                  <label>Nueva ciudad</label>
                  <input v-model="nueva_ciudad" class="form-control" type="text">
                  <div class="text-end">
                    <a v-on:click="set_nueva_ciudad()" href="javascript:void(0)">Crear</a>
                  </div>
                  <div class="text-end">
                    <a v-on:click="load_nueva_ciudad = false" href="javascript:void(0)">Cancelar</a>
                  </div>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Nombre del aliado <small>(razon social o nombre comercial)</small></label>
                  <input v-model="aliado.nombre_aliado" class="form-control" type="text" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>NIT del aliado <small>(identificación que sale en el RUT, escribirlo sin puntos, preferiblemente
                      no poner digito de verificación)</small></label>
                  <input v-model="aliado.nit_aliado" class="form-control" type="text" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>

                <div class="col-lg-12 form-group">
                  <label>WhatsApp <small>(preferiblemente cuenta empresarial)</small></label>
                  <input v-model="aliado.whatsapp" v-on:blur="copiar(1)" class="form-control" type="text"
                    @keypress="isNumber($event)" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                      " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Celular <small>(preferiblemente número empresarial)</small></label>
                  <input v-model="aliado.telefono" class="form-control" type="text" @keypress="isNumber($event)"
                    :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                      " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Correo electrónico <small>(Validar bien antes de guardar, es obligatorio, no se puede poner un
                      correo inexistente)</small></label>
                  <input v-model="aliado.email" class="form-control" type="mail" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Facebook <small>( nombre de como aparece en url o en su defecto id )</small></label>
                  <input v-model="aliado.facebook" class="form-control" type="text" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Instagram <small>(nombre tal cual como aparece en la @)</small></label>
                  <input v-model="aliado.instagram" class="form-control" type="text" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Zona <small>(ubicación cardinal Norte, Sur, centro, oriente, occidente)</small></label>
                  <select v-model="aliado.zona" class="form-control" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    ">
                    <option value="null">Selecciona la zona</option>
                    <option value="1">Norte</option>
                    <option value="2">Sur</option>
                    <option value="3">Oriente</option>
                    <option value="4">Occidente</option>
                    <option value="5">Centro</option>
                  </select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Dirección principal establecimiento <small>(dirección de la sede principal)</small></label>
                  <input v-model="aliado.direccion" class="form-control" type="text" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div v-if="loading_ubicacion" class="col-lg-12 text-center text-info">
                  Espera. Detectando ubicación...
                </div>
                <div class="col-lg-6 form-group">
                  <label>Latitud</label>
                  <input v-model="aliado.lat" class="form-control" type="text" />
                </div>
                <div class="col-lg-6 form-group">
                  <label>Longitud</label>
                  <input v-model="aliado.lng" class="form-control" type="text" />
                  <div class="text-end">
                    <a v-on:click="get_ubicacion" href="javascript:void(0)">Detectar ubicación</a>
                  </div>
                </div>

                <div class="col-lg-12 form-group">
                  <label>Categoría <small>(grupo al que pertenece el negocio aliado)</small></label>
                  <select v-model="aliado.id_categoria" class="form-control" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    ">
                    <option value="null">Selecciona una categoría</option>
                    <option v-for="(categoria, index_categoria) in categorias" v-bind:key="index_categoria"
                      v-bind:value="categoria.id_categoria">
                      {{ categoria.categoria }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Nombre del representante legal <small>(nombre completo con apellidos)</small></label>
                  <input v-model="aliado.representante_legal" v-on:blur="copiar(2)" class="form-control" type="text"
                    :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                      " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Identificación del representante legal <small>(numero de cedula sin puntos)</small></label>
                  <input v-model="aliado.identificacion_representante_legal" class="form-control" type="text"
                    @keypress="isNumber($event)" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                      " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Nombre del contacto <small>(por defecto es el representante legal, pero se puede poner alguien
                      especifico, nombre completo con apellidos)</small></label>
                  <input v-model="aliado.nombre_contacto" class="form-control" type="text" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Celular del contacto <small>(numero telefonico del contacto principal)</small></label>
                  <input v-model="aliado.telefono_contacto" class="form-control" type="text" @keypress="isNumber($event)"
                    :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                      " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Correo electrónico del contacto <small>(Correo electrónico del contacto principal preferiblemente
                      del representante legal)</small></label>
                  <input v-model="aliado.email_contacto" class="form-control" type="text" @keypress="isNumber($event)"
                    :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                      " />
                </div>
              </div>
              <div v-if="session.usuario.perfil == 0" class="col-lg-12 form-group">
                <label>Agente</label>
                <v-select v-model="aliado.usuario" label="nombre_completo" :options="usuarios"
                  v-on:search="get_usuarios"></v-select>
              </div>
              <div v-if="session.usuario.nombres == 'IVENS'" class="col-lg-12 form-group">
                <label>Estado</label>
                <select v-model="aliado.estado_aliado" class="form-control">
                  <option value="0">Interesado</option>
                  <option value="1">Pendiente</option>
                  <option value="2">Completa</option>
                  <option v-if="session.usuario.perfil == 0" value="3">
                    Exitosa
                  </option>
                </select>
              </div>
              <!--  <div
                v-if="session.usuario.perfil == 0 && aliado.estado_aliado == 2"
                class="col-lg-12 form-group"
              >
                <label>Estado en App</label>
                <select v-model="aliado.estado_app" class="form-control">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div> -->

              <div class="mt-2 mb-2 text-end">
                <button v-on:click="update_aliado(1)" class="btn btn-orange btn-lg rounded-pill">
                  <i class="bx bx-save"></i> Guardar y finalizar
                </button>
                <button v-on:click="update_aliado(2)" class="btn btn-success btn-lg rounded-pill ms-1">
                  <i class="bx bx-save"></i> Guardar y continuar
                  <i class="bx bx-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <router-link v-bind:to="'/aliado/' + id_aliado" class="btn btn-outline-secondary rounded-pill">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>

            <br />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Aliado_info_basica",
  metaInfo: {
    title: "Aliados - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      loading_ubicacion: false,
      id_aliado: null,
      aliado: [],
      categorias: [],
      sucursales: [],
      usuarios: [],
      load_nueva_ciudad: false,
      nueva_ciudad: null,
      ciudades: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
    this.get_categorias();
    this.get_sucursales();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_sucursales: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/sucursales", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.sucursales = response.data.data.sucursales;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_ciudades: function (search) {
      if (search == null || search.trim().length == 0) {
        return false;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(this.$base_url + "admin/ciudades", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.ciudades = response.data.data.ciudades;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    set_nueva_ciudad: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        nueva_ciudad: this.nueva_ciudad,
        id_aliado: this.id_aliado,
      };
      axios
        .post(this.$base_url + "admin/set_ciudad", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Excelente!",
              text: response.data.message,
            });
          }
          vm.get_aliado();
          vm.get_sucursales();
          vm.load_nueva_ciudad = false;
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    get_categorias: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/categorias", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.categorias = response.data.data.categorias;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_usuarios: function (search) {
      if (search == null || search.trim().length == 0) {
        return false;
      }

      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(this.$base_url + "admin/usuarios", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuarios = response.data.data.usuarios;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    update_aliado: function (step) {
      if (
        this.aliado.nombre_aliado == null ||
        this.aliado.nombre_aliado.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita el nombre del aliado.",
        });
        this.$refs.nombre_aliado.focus();
        return false;
      }
      if (this.aliado.sucursal == null) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Selecciona la ciudad a donde pertenece el aliado.",
        });
        return false;
      }

      var re = /\S+@\S+\.\S+/;
      var valida_email = re.test(this.aliado.email);

      if (!valida_email) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita una dirección de correo electrónico válida.",
        });
        return false;
      }

      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        aliado: this.aliado,
      };
      axios
        .post(this.$base_url + "aliados/update_aliado", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Excelente!",
              text: response.data.message,
            });
          }
          switch (step) {
            case 1:
              vm.$router.push("/");
              break;
            case 2:
              vm.$router.push("/aliado/info_secundaria/" + vm.id_aliado);
              break;
          }

          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    get_ubicacion: function () {
      this.loading_ubicacion = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.aliado.lat = position.coords.latitude;
          this.aliado.lng = position.coords.longitude;
          this.loading_ubicacion = false;
        },
        (error) => {
          alert(error.message);
          this.loading_ubicacion = false;
        }
      );
    },
    copiar: function (campo) {
      switch (campo) {
        case 1:
          if (this.aliado.telefono == null || this.aliado.telefono == "") {
            this.aliado.telefono = this.aliado.whatsapp;
          }

          if (
            this.aliado.telefono_contacto == null ||
            this.aliado.telefono_contacto == ""
          ) {
            this.aliado.telefono_contacto = this.aliado.whatsapp;
          }
          break;

        case 2:
          if (
            this.aliado.nombre_contacto == null ||
            this.aliado.nombre_contacto == ""
          ) {
            this.aliado.nombre_contacto = this.aliado.representante_legal;
          }
          break;
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode == 46) {
        evt.preventDefault();
      } else {
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
  },
};
</script>